import { baseUniDriverFactory } from '../../test-utils/utils/unidriver';

export const headerUniDriverFactory = base => {
  return {
    ...baseUniDriverFactory(base),
    /** Returns size property value */
    getSize: () => base.attr('data-size'),
  };
};
